import initialState from "../../../Client/redux/reducers/initialState";
import { LiveSwitchAction } from "../../../LiveSwitch/liveSwitchActions";
import { Registration } from "../../../Shared/GeneratedTypes";
import * as types from "../actions/actionTypes";
import { CurrentMentorsActions } from "../actions/currentClientActions";

export default function registrationReducer(
    state: Registration[] | null = initialState.registrations,
    action: CurrentMentorsActions | LiveSwitchAction
): Registration[] | null {
    switch (action.type) {
        case types.HEARTBEAT_COMPLETE:
            return action.heartBeatResult.registrations;
    }

    return state;
}
